export const ds_VideoLayoutBlock_Entry = `
    fragment ds_VideoLayoutBlock_Entry on ds_VideoLayoutBlock_Entry {
        id
        canonicalUid
        video_ColorPalette
        video_ColorTheme
        video_TextPosition
        video_Text
        video_Height
        video_CustomHeight
        video_ContentAlignment
        video_Padding

        video_CoverImage {
            url
            title
            alt
            focalPoint
        }
        video_Video {
            ... on ds_VideosSection_Entry {
                title
                videoUrl
                videoType
                url
                videoFile {
                    url
                }
            }
        }
    }
`
